import { API_ENDPOINTS } from "../../../config/api";
import { React, useState, useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcumbs";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
// RESOURCES
import folderIcon from "../../../assets/images/folderIcon.png";
import { useAlert } from "../../../hooks/AlertHook";

const pages = [
  { name: "Devices", href: "/dash/devices", current: false },
  { name: "Collections", href: "", current: true },
];

export default function CollectionsPage(props) {
  const [collection, setCollection] = useState([]);
  const navigate = useNavigate();
  const deviceid = props.deviceSelected.ID;
  const alerta = useAlert();

  useEffect(() => {
    // let { token } = JSON.parse(localStorage.getItem('BACK_API')) || {};
    // alerta.setShow(false);
    axios
      .post(
        API_ENDPOINTS.GET_COLLECTIONS,
        { deviceid }
        // { headers: {authorization: `bearer ${token}`}}
      )
      .then((respuesta) => {
        if (respuesta.data.length > 0) {
          alerta.setShow(false);
          setCollection(respuesta.data);
        } else {
          alerta.setMessage("Device is Empty");
          alerta.setShow(true);
          setTimeout(() => {
            alerta.setShow(false);
            navigate("/dash/devices");
          }, 1000);
        }
      })
      .catch((error) => {
        // console.log('error:', error)
        navigate("/auth/login");
      });

  }, [alerta, deviceid, navigate]);

  const showCollection = (
    <table className="min-w-full divide-y divide-gray-200">
      <thead className="bg-gray-50">
        <tr>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Collection ID
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Screenings
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Status
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Last Sync
          </th>
          <th scope="col" className="relative px-6 py-3">
            <span className="sr-only">Explore</span>
          </th>
        </tr>
      </thead>

      <tbody className="bg-white divide-y divide-gray-200">
        {collection.map((collection) => (        
          <tr key={`collection-${collection.ID}`}>
            <td className="px-6 py-4 whitespace-nowrap">
              <div className="flex items-center">
                <div className="flex-shrink-0 h-10 w-10">
                  <img className="h-10 w-10" src={folderIcon} alt="" />
                </div>
                <div className="ml-4">
                  <Link
                    to={`/dash/devices/${collection.deviceid}/collection/${collection.ID}/screenings`}
                    className="text-sm font-medium text-gray-900"
                  >
                    {collection.collectionname}
                  </Link>
                  <p className="text-sm text-gray-500">
                    {props.deviceSelected.deviceName}
                  </p>
                </div>
              </div>
            </td>
            <td className="px-6 py-4 whitespace-nowrap">
              <p className="text-sm text-gray-900">
                {collection.numberofimages} Screenings
              </p>
              <p className="text-sm text-gray-500">
                {/* {collection.collectionOperator} */}
                Operator
              </p>
            </td>
            <td className="px-6 py-4 whitespace-nowrap">
              <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                {/* {collection.collectionStatus} */}
                Status
              </span>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              {collection.CreatedAt}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
              <Link
                to={`/dash/devices/${collection.deviceid}/collection/${collection.ID}/screenings`}
                className="text-indigo-600 hover:text-indigo-900"
              >
                Explore
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  const showAlert = (
    <div className="alert alert-yellow">
      <span>{alerta.message}</span>
    </div>
  );

  const cardContent = collection.length > 0 ? showCollection : showAlert;

  return (
    <>
      <Breadcrumbs pages={pages} />
      <div className="card">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Collections for "{props.deviceSelected.systemname}"
          </h3>
        </div>

        <div className="flex flex-col">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                {cardContent}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
